import type {
	PricingCardType,
	SubscriptionPeriod,
	SubscriptionPlan,
} from "../../../types";
import { PricingCard } from "../PricingCard";

type Props = {
	list?: PricingCardType[];
	onSubscriptionChange: (data: {
		plan: SubscriptionPlan;
		period: SubscriptionPeriod;
	}) => void;
};

export const PricingCardList: React.FC<Props> = ({
	list = [],
	onSubscriptionChange,
}) => {
	return (
		<div className="grid grid-cols-1 @3xl:grid-cols-2 @7xl:grid-cols-4 gap-10">
			{list?.length > 0 &&
				list.map((item) => (
					<PricingCard
						data-testid="pricing-card"
						key={item.id}
						card={item}
						handleSubmit={onSubscriptionChange}
					/>
				))}
		</div>
	);
};
